import { LanguageTranslationViewModel } from './language-translation-view.model';

export class LanguageTranslationSetViewModel {
    public languageTranslationSetId: string;
    public languageTranslationName: string;
    public statusCode: string;
    public languageTranslations: LanguageTranslationViewModel[];
}